import { useMemo, useState } from 'react';
import { FiltersEntry } from 'modules/shared/components/filters/interfaces/filters-entry.interface';
import { ActiveFiltersInterface } from 'modules/shared/components/filters/interfaces/active-filters.interface';
import { FiltersGroup } from 'modules/shared/components/filters/interfaces/filters-group.interface';
import { ProducerUrlManagerInterface } from 'modules/producers/interfaces/producer-url-manager.interface';

export const useActiveFilters = (
    filtersIds: ProducerUrlManagerInterface['filters'],
    filters: {
        groups: FiltersGroup[];
    }
): ActiveFiltersInterface[] => {
    // We save initial filters state
    const [initialIds] = useState(filtersIds ?? []);

    // The last section is recalculated for every filters changes
    return useMemo(() => {
        const result: ActiveFiltersInterface[] = [];

        filters.groups.forEach(group => {
            const items: FiltersEntry[] = [];

            group.entries.forEach(entry => {
                if (initialIds?.includes(entry.id)) {
                    items.push(entry);
                }
            });

            if (items.length) {
                result.push({ groupName: group.name, items });
            }
        });

        return result;
    }, [initialIds, filters.groups]);
};
